import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core';
import styles from './styles';

import { selectLocksActive, selectLocksReturned } from '../../redux/selectors/locks';
import { selectSmartLocks, selectSmartLocksActive } from '../../redux/selectors/smartLocks';
import { selectWifiThermostats, selectWifiThermostatsActive } from '../../redux/selectors/wifiThermostats';

import { clearFilter } from '../../redux/actions/filter';
import { locksRequest } from '../../redux/actions/locks';
import { smartLocksRequest } from '../../redux/actions/smartLocks';
import { wifiThermostatsRequest } from '../../redux/actions/wifiThermostats';
import { exportAllRequest } from '../../redux/actions/exportAll';

import { AppState } from '../../redux/store';
import { getHubsRequest } from '../../redux/actions/hubs/hubs';
import { selectHubs } from '../../redux/selectors/hubs';

import Inventory from './Inventory';
import { getBuilderId } from '../../redux/selectors/auth';

const mapStateToProps = (state: AppState) => ({
  locksActive: selectLocksActive(state),
  smartLocksActive: selectSmartLocksActive(state),
  wifiThermostatsActive: selectWifiThermostatsActive(state),
  locksReturned: selectLocksReturned(state),
  smartLocks: selectSmartLocks(state),
  wifiThermostats: selectWifiThermostats(state),
  hubs: selectHubs(state),
  builderId: getBuilderId(state),
});

const mapDispatchToProps = {
  loadLocks: locksRequest,
  loadSmartLocks: smartLocksRequest,
  loadWifiThermostats: wifiThermostatsRequest,
  loadHubs: getHubsRequest,
  clearFilterState: clearFilter,
  exportAllProperties: exportAllRequest,
};

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(Inventory),
);
